import { getPage } from '../content/source.js';
import ContentPage from '../content/ContentPage.jsx';

const page = getPage('demo-terms');

export function meta() {
  return [{ title: `${page.title} · WriteUp` }, { name: 'description', content: page.description }];
}

export default function DemoTermsRoute() {
  return <ContentPage page={page} />;
}
